import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=12b5df6e&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
import style0 from "./Phone.vue?vue&type=style&index=0&id=12b5df6e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5df6e",
  null
  
)

export default component.exports